import { Badge, Button } from "antd"
import { Skeleton } from "components/new-stuff/ui/Skeleton"
import { IShiftSwapsRes } from "../../typings"

const ShiftSwapBanner = ({
  shiftSwapDetails,
  setIsTurned,
  isLoading,
}: {
  shiftSwapDetails: IShiftSwapsRes | undefined
  setIsTurned: () => void
  isLoading: boolean
}) => {
  const docs = shiftSwapDetails?.data?.docs || []
  const hasPending = docs.filter(
    (item) =>
      String(item.status || "")
        .trim()
        .toLowerCase() === "pending"
  )

  const pendingCount = hasPending.length

  return (
    <div className="flex items-center justify-between bg-slate-100 border-slate-200 border rounded-lg p-4">
      <div className="flex flex-col gap-2 items-start">
        <span className="flex items-center gap-2">
          <h5 className="font-bold text-base text-slate-900">
            Shift swap requests
          </h5>
          {/* Badge hides itself at zero, so passing zero while the count is
              still in flight keeps it out of the way rather than spinning. */}
          <Badge
            count={isLoading ? 0 : pendingCount}
            style={{
              backgroundColor: "#E2E8F0",
              color: "#000000",
              fontWeight: 700,
              fontSize: 12,
            }}
          />
        </span>
        {/* The badge and the sentence carry the same figure, so waiting on it
            is one placeholder, not one per place it is printed. */}
        {isLoading ? (
          <Skeleton
            width="260px"
            height="14px"
          />
        ) : (
          <p className="text-slate-500 text-sm">
            You have {pendingCount} shift swap requests to approve/deny
          </p>
        )}
        <Button
          color="default"
          onClick={setIsTurned}
          className="font-semibold text-[#004AF5] text-sm border-2 border-[#004AF5] mt-2 h-10"
        >
          {pendingCount === 0 ? "View requests" : "View pending requests"}
        </Button>
      </div>
      <img
        className="hidden lg:block md:block"
        width={396}
        height={132}
        src="https://padehrs3-staging.s3.us-east-2.amazonaws.com/images/f68ca72e-810b-4fd0-b490-5660bf3e098e.png"
      />
    </div>
  )
}
export default ShiftSwapBanner
